import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Box,
  Chip,
  Menu,
  MenuItem,
  TextField,
  Checkbox,
} from "@mui/material";
import "../../analytics/process/process.scss";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";
import "./review.scss";

export default function ParameterTable({
  data,
  onView,
  tableHeaders,
  openData,
  moreOption,
  handleMenuOption,
  handleMenuOptionDownload,
  selectedCheck,
  handleCheckBox,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedRow, setSelectedRow] = useState();

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box width="100%">
      <TableContainer
        component={Paper}
        overflow="auto"
        sx={{
          maxHeight: "calc(100vh - 220px)",
          boxShadow: "none",
          tableLayout: "auto",
        }}
      >
        <Table stickyHeader>
          <TableHead positon="sticky" top={0} className="table-header">
            <TableRow>
              <TableCell className="table-header-cell" sx={{ minWidth: 30 }}>
                Sr No.
              </TableCell>
              <TableCell className="table-header-cell">File Name</TableCell>
              <TableCell
                className="table-header-cell"
                sx={{ pl: "45px !important" }}
              >
                Status
              </TableCell>
              <TableCell className="table-header-cell">Uploaded On</TableCell>
              <TableCell className="table-header-cell">Uploaded By</TableCell>
              <TableCell
                className="table-header-cell"
                sx={{ textAlign: "center" }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& .MuiTableRow-root": { height: 48 },
              "& .MuiTableCell-root": { py: 0.5 },
            }}
          >
            {data?.data?.data?.map((row, index) => (
              <TableRow key={row.batch_id}>
                <TableCell sx={{ fontSize: 14 }}>
                  {data?.data?.page_size * (data?.data?.page - 1) + index + 1}
                </TableCell>
                {/* <TableCell>
                  <Checkbox checked={selectedCheck.includes(row.batch_id)} onChange={()=>handleCheckBox(row?.batch_id)} size="small" sx={{ p: 0, pl: 0.5 }} />
                </TableCell> */}
                <TableCell sx={{ fontSize: 14 }}>{row.file_name}</TableCell>
                <TableCell sx={{ fontSize: 14 }}>
                  <Chip
                    label={row.status}
                    className={`review-status-chip status-chip ${row?.status?.toLowerCase() === "success" ? "status-chip-color-green" : "status-chip-color-gray"}`}
                  />
                </TableCell>
                <TableCell sx={{ fontSize: 14 }}>{row.uploaded_at}</TableCell>

                {/* <TableCell sx={{ fontSize: 14 }}>{row.step_name }</TableCell> */}
                <TableCell sx={{ fontSize: 14 }}>{row.uploaded_by}</TableCell>

                <TableCell sx={{ textAlign: "center" }}>
                  {row.error_logs || row.success_logs || row.file_logs ? (
                    <IconButton
                      size="small"
                      onClick={(e) => handleClick(e, row)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  ) : (
                    ""
                  )}
                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    PaperProps={{
                      sx: {
                        boxShadow: "none",
                        border: "1px solid #ccc",
                        padding: 0,
                        minWidth: "100px",
                        backgroundColor: "transparent",
                      },
                    }}
                    MenuListProps={{
                      sx: {
                        padding: 0,
                        backgroundColor: "white",
                        borderRadius: 0,
                      },
                    }}
                  >
                    {selectedRow?.file_logs && (
                      <MenuItem
                        sx={{ py: 0.4 }}
                        key={"succcess"}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClose();
                          handleMenuOption(selectedRow, "filelogs");
                        }}
                      >
                      View Error Logs
                      </MenuItem>
                    )}
                    {selectedRow?.success_logs && (
                      <MenuItem
                        sx={{ py: 0.4 }}
                        key={"succcess"}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClose();
                          handleMenuOption(selectedRow, "success");
                        }}
                      >
                       View Success Logs
                      </MenuItem>
                    )}
                    {selectedRow?.error_logs && (
                      <MenuItem
                        sx={{ py: 0.4 }}
                        key={"error"}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClose();
                          handleMenuOption(selectedRow, "error");
                        }}
                      >
                       View Error Logs
                      </MenuItem>
                    )}
                    {selectedRow?.file_logs && (
                      <MenuItem
                        sx={{ py: 0.4 }}
                        key={"succcess"}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClose();
                          handleMenuOptionDownload(selectedRow, "filelogs");
                        }}
                      >
                      Download Error Logs
                      </MenuItem>
                    )}
                    {selectedRow?.success_logs && (
                      <MenuItem
                        sx={{ py: 0.4 }}
                        key={"succcess"}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClose();
                          handleMenuOptionDownload(selectedRow, "success");
                        }}
                      >
                       Download Success Logs
                      </MenuItem>
                    )}
                    {selectedRow?.error_logs && (
                      <MenuItem
                        sx={{ py: 0.4 }}
                        key={"error"}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClose();
                          handleMenuOptionDownload(selectedRow, "error");
                        }}
                      >
                       Download Error Logs
                      </MenuItem>
                    )}
                  </Menu>
                </TableCell>
              </TableRow>
            ))}
            {!data?.loader && data?.data?.data.length === 0 && (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Typography color="textSecondary">No data found</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
